import { render, staticRenderFns } from "./DsnFormHeader.vue?vue&type=template&id=d71474f6&"
import script from "./DsnFormHeader.vue?vue&type=script&lang=js&"
export * from "./DsnFormHeader.vue?vue&type=script&lang=js&"
import style0 from "./DsnFormHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports